import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../hoc/withTokenInterceptor/withTokenInterceptor';
import { initializePageAction } from '../../store/theme.actions';
import LancamentosComissionados from './LancamentosComissionados';

function CadastrarContaCorrenteComissionadoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Conta-Corrente de Comissionado > Novo Lançamento'));

  return (
    <LancamentosComissionados isInsertMode />
  );
}
export default withTokenInterceptor(CadastrarContaCorrenteComissionadoPage);
